<template>
    <div class="home-page__outer">
        <div class="home-page__element">
            <b-row no-gutters>
                <b-col lg="12">
                    <img class="logo" src="../../../assets/img/futuronetwork-logo--white.png" alt="FuturoNetwork">
                </b-col>
            </b-row>
        </div>
        <div class="home-page__element home-page__element__dark"
             v-if="canRegister === 'CAN_REGISTER'">
            <b-row no-gutters>
                <b-col lg="12">
                    <h1 class="title" v-if="userData && userData.sponsor">
                        Welcome to FuturoNetwork <br class="desktop-only">online business
                    </h1>
                    <h1 class="title" v-else>
                        Thank you for your interest <br class="desktop-only">in FuturoNetwork™ platform
                    </h1>
                </b-col>
            </b-row>
            <form @submit.prevent="validate()"
                  v-if="userData && userData.sponsor"
                  class="full">
                <b-row class="register-form">
                    <b-col  lg="6">
                        <textfield v-if="userData.sponsor && userData.sponsor !== 'futurenet'"
                                   :name="'your_sponsor_name'"
                                   :label="'Sponsor'"
                                   :progress="progress"
                                   :update-value="updateValue"
                                   :disabled="true"
                                   :default="'Sponsor: ' + userData.sponsor"></textfield>
                        <textfield :name="'first_name'"
                                   :label="'first name'"
                                   :progress="progress"
                                   :rules="'required|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"></textfield>
                        <textfield :name="'last_name'"
                                   :label="'last name'"
                                   :progress="progress"
                                   :rules="'required|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"></textfield>
                        <textfield :name="'login'"
                                   :label="'login'"
                                   :progress="progress"
                                   :rules="'required|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"></textfield>
                        <textfield :name="'email'"
                                   :label="'email address'"
                                   :progress="progress"
                                   :rules="'required|email|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"></textfield>
                        <textfield :name="'email_confirmation'"
                                   :label="'repeat email address'"
                                   :progress="progress"
                                   :rules="'required|email|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"></textfield>
                    </b-col>
                    <b-col lg="6">
                        <div class="form-item form-input"
                             :class="{ 'form-item--error': errors.has('password') && showErrors }">
                            <input type="password"
                                   placeholder="Password"
                                   name="password"
                                   id="register_form_password"
                                   v-model="userData.password"
                                   ref="password"
                                   v-validate
                                   data-vv-rules="required|min:8|max:255"
                                   data-vv-as="password"
                                   :disabled="progress">
                            <p class="field-error--description field-error--description--white" v-show="errors.has('password') && showErrors">{{ errors.first('password') }}</p>
                        </div>
                        <div class="form-item form-input"
                             :class="{ 'form-item--error': errors.has('repeat_password') && showErrors }">
                            <input type="password"
                                   placeholder="Repeat password"
                                   name="repeat_password"
                                   id="register_form_repeat_password"
                                   v-model="userData.password_confirmation"
                                   v-validate
                                   data-vv-rules="required|confirmed:password|max:255"
                                   data-vv-as="repeat password"
                                   :disabled="progress">
                            <p class="field-error--description field-error--description--white" v-show="errors.has('repeat_password') && showErrors">{{ errors.first('repeat_password') }}</p>
                        </div>
                        <div class="form-radios">
                            <div class="radios">
                                <div class="form-item form-radio"
                                     :class="{ 'form-item--error': errors.has('gender') && showErrors }">
                                    <input type="radio"
                                           name="gender"
                                           id="account_type_personal"
                                           value="male"
                                           v-model="userData.gender"
                                           v-validate
                                           data-vv-as="account type"
                                           data-vv-rules="required"
                                           :disabled="progress">
                                    <label for="account_type_personal">Personal account</label>
                                    <div class="check"></div>
                                </div>
                                <div class="form-item form-radio"
                                     :class="{ 'form-item--error': errors.has('gender') && showErrors }">
                                    <input type="radio"
                                           name="gender"
                                           id="account_type_company"
                                           value="company"
                                           v-model="userData.gender"
                                           v-validate
                                           data-vv-as="account type"
                                           data-vv-rules="required"
                                           :disabled="progress">
                                    <label for="account_type_company">Company account</label>
                                    <div class="check"></div>
                                </div>
                            </div>
                            <p class="field-error--description field-error--description--white" v-show="errors.has('gender') && showErrors">{{ errors.first('gender') }}</p>
                        </div>
                        <textfield :name="'company_name'"
                                   :label="'company name'"
                                   :progress="progress"
                                   :rules="'required|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"
                                   v-if="userData.gender === 'company'"></textfield>
                        <textfield :name="'company_registration_number'"
                                   :label="'company registration number'"
                                   :progress="progress"
                                   :rules="'required|max:255'"
                                   :show-errors="showErrors"
                                   :update-value="updateValue"
                                   v-if="userData.gender === 'company'"></textfield>
                    </b-col>
                </b-row>
                <b-row class="register-form">
                    <b-col cols="12">
                        <div v-for="(term, index) in termsList"
                             :key="index">
                            <checkbox  :message="term.content"
                                       :name="term.key"
                                       :label="'terms and conditions'"
                                       :progress="progress"
                                       :rules="term.required ? 'required' : ''"
                                       :show-errors="showErrors"
                                       :update-value="updateValue"></checkbox>
                        </div>
                        <div class="form-item form-recaptcha"
                             :class="{ 'form-item--error': errors.has('recaptcha') && showErrors }">
                            <vue-recaptcha
                                    class="g-recaptcha"
                                    @verify="onVerify"
                                    @render="onRender"
                                    :sitekey="recaptcha.sitekey">
                            </vue-recaptcha>
                            <p class="field-error--description field-error--description--white" v-show="errors.has('recaptcha') && showErrors">{{ errors.first('recaptcha') }}</p>
                        </div>
                    </b-col>
                    <b-col lg="6" class="buttons">
                        <button class="button--primary"
                                :class="{ 'button--progress': progress }"
                                :type="progress ? 'button' : 'submit'">Register</button>
                    </b-col>
                </b-row>
            </form>
            <p class="to-login tl" style="margin-top: 20px;">
                Do you have an account?
                <br>
                <a style="cursor: pointer"
                   @click="goToLogin()">Log in FuturoNetwork</a>
            </p>
        </div>
        <div class="home-page__element home-page__element__dark"
             v-else="canRegister === 'CAN_NOT_REGISTER'">
            <b-row no-gutters>
                <b-col lg="12">
                    <h1 class="title">
                        In some countries registration for the service has been blocked for legal reasons. You can not register.
                    </h1>
                    <p class="to-login tl" style="margin-top: 20px;">
                        Do you have an account?
                        <br>
                        <a style="cursor: pointer"
                           @click="goToLogin()">Log in FuturoNetwork</a>
                    </p>
                </b-col>
            </b-row>
        </div>
        <div class="home-page__element"></div>
    </div>
</template>

<script>
    import Checkbox from './fields/Checkbox.vue';
    import Textfield from './fields/Textfield.vue';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        dependencies: ['account', 'api', 'recaptcha', 'terms'],
        components: { Checkbox, Textfield, VueRecaptcha },
        data () {
            return {
                canRegister: 'IN_PROGRESS',
                userData: {},
                progress: false,
                showErrors: false
            }
        },
        computed: {
            termsList () {
                return this.$store.getters.terms;
            }
        },
        methods: {
            onVerify: function (response) {
                this.recaptcha.SetRecaptchaResponse(response);
                this.userData['g-recaptcha-response'] = response;
            },
            onRender: function(recaptchaId) {
                this.recaptchaId = recaptchaId;
            },
            changeView (view) {
                this.$store.commit('loginFormView', 2);
                setTimeout(() => {
                    this.$store.commit('loginFormView', view);
                }, 600);
            },
            goToLogin () {
                this.$store.commit('loginFormView', 2);
                setTimeout(() => {
                    this.$router.push({ name: 'Login' });
                }, 600);
            },
            updateValue (field, value) {
                this.userData[field] = value;
            },
            validate () {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    }
                    else {
                        this.showErrors = true;
                    }
                });
            },

            submit () {
                this.progress = true;
                this.account.save(this.userData)
                    .then(() => {
                        this.progress = false;
                        this.goToLogin();
                    }, () => {
                        this.progress = false;
                        delete this.userData['g-recaptcha-response'];
                        this.$children.find(( component ) => {
                            return component.$widgetId === this.recaptchaId;
                        }).reset();
                    })
                }
        },
        beforeCreate () {
            this.$store.commit('loginFormView', 2);
        },
        beforeMount () {
            const location = this.$store.getters.location;

            if (location && location !== 'Poland') {
                this.userData = {
                    login                       : '',
                    first_name                  : '',
                    last_name                   : '',
                    email                       : '',
                    email_confirmation          : '',
                    password                    : '',
                    password_confirmation       : '',
                    gender                      : '',
                    company_name                : '',
                    company_registration_number : '',
                    sponsor                     : this.$route.params.sponsor ? this.$route.params.sponsor : 'futurenet',
                };

                this.terms.fetchData().then(() => {
                    let terms = this.termsList;

                    for (let term in terms) {
                        this.$set(this.userData, terms[term].key, false);
                    }
                });

                this.canRegister = 'CAN_REGISTER';
            } else {
                this.canRegister = 'CAN_NOT_REGISTER';
            }
        },
        mounted () {
            this.changeView(4);
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_guest.scss';

    .no-sponsor p{
        margin: 25px 0;
        color: $white;
    }

    .to-login{
        margin: 0 0 30px;
        color: white;
        text-align: center;
        font-weight: bold;
        font-size: 16px;

        &.tl{
            text-align: left;
         }
    }

    a{
        color: white;

        &:hover,
        &:focus{
             text-decoration: underline;
        }
    }

    .logo{
        margin: 30px auto !important;
    }

    .title{
        color: $white;
        font-weight: bold;
        font-size: 34px;
        line-height: 1.2;

        @media(max-width: 767px){
            text-align: center;
            font-size: 26px;
        }
    }

    .buttons{
        width: 100%;
        justify-content: center;
    }

    .g-recaptcha {
        padding-right: 15px;
        transform:scale(0.894);
        transform-origin:0 0;
    }

    .register-form .buttons{
        padding-right: 0;

        button{
            @media(min-width: 992px){
                width: 100%;
                line-height: 39px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/register/partials/RegisterForm.vue